/**
 * Build the WhatsApp / share caption shown in the share dialog and sent
 * alongside the PDF/PNG file.
 *
 * Format:
 *   balance >  0  →  "<inr> Total due"    (party owes user)
 *   balance <  0  →  "<inr> Aapke"        (user owes party)
 *   balance == 0  →  "Settled"
 *
 * Direction is communicated by the word, not by sign — the absolute value is
 * always used for the formatted amount. NaN / unparseable / empty input
 * resolves to "Settled" defensively so we never send garbage as a caption.
 */
import { kinrToInrDisplay } from '../money/inr';

export function buildShareCaption(kinrBalance: string): string {
  const n = parseFloat(kinrBalance);
  if (!Number.isFinite(n) || n === 0) return 'Settled';
  const abs = Math.abs(n).toString();
  const inr = kinrToInrDisplay(abs);
  return n > 0 ? `${inr} Total due` : `${inr} Aapke`;
}
